import * as React from 'react';
import type { SVGProps } from 'react';
const SvgSupport = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns='http://www.w3.org/2000/svg' width={34} height={34} fill='none' {...props}>
    <rect width={34} height={34} fill='#FF9800' rx={6} />
    <path
      stroke='#fff'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={1.5}
      d='M10.25 17.75v-1.5a6.75 6.75 0 0 1 13.5 0v1.5M23.75 17.75v1.227c0 1.465-.553 2.87-1.538 3.905A5.12 5.12 0 0 1 18.5 24.5'
    />
    <path
      stroke='#fff'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={1.5}
      d='M23.75 19.25a1.5 1.5 0 0 1-1.5 1.5h-.75a1.5 1.5 0 0 1-1.5-1.5V17a1.5 1.5 0 0 1 1.5-1.5h2.25zm-13.5 0a1.5 1.5 0 0 0 1.5 1.5h.75a1.5 1.5 0 0 0 1.5-1.5V17a1.5 1.5 0 0 0-1.5-1.5h-2.25zM16.357 24.5a.84.84 0 0 1-.606-.264.92.92 0 0 1-.251-.636v-.45c0-.239.09-.468.251-.636a.84.84 0 0 1 .606-.264h1.286c.227 0 .445.095.606.264.16.168.251.397.251.636v1.35z'
    />
  </svg>
);
export default SvgSupport;
